
export default {
  name: 'ProdukttourenPage',
  nuxtI18n: {
    paths: {
      de: '/lp/tour',
      en: '/lp/tour'
    }
  },
  async asyncData({ $prismic, error, app }) {
    try {
      const currentLocale = app.i18n && app.i18n.localeProperties 
        ? app.i18n.localeProperties.prismic 
        : 'de-de'

      const document = await $prismic.api.getSingle('produkttouren', { lang: currentLocale })
      
      return { document }
    } catch (e) {
      error({ statusCode: 404, message: 'Landingpage in Prismic nicht gefunden' })
    }
  },
  data() {
    return {
      activeModalUrl: null
    }
  },
  computed: {
    isEnglish() {
      return this.$i18n && this.$i18n.locale && this.$i18n.locale.includes('en')
    }
  },
  head() {
    if (!this.document) return {}
    const defaultTitle = this.isEnglish ? 'ATHLYZER Product Tours' : 'ATHLYZER Produkttouren'
    const metaTitle = this.$prismic.asText(this.document.data.meta_title) || defaultTitle
    const metaDesc = this.document.data.meta_description || ''
    const ogImage = this.document.data.og_image?.url || '/ATHLYZER_OG.jpg'
    
    return {
      title: metaTitle,
      meta: [
        { hid: 'description', name: 'description', content: metaDesc },
        { hid: 'og:title', property: 'og:title', content: metaTitle },
        { hid: 'og:description', property: 'og:description', content: metaDesc },
        { hid: 'og:image', property: 'og:image', content: ogImage }
      ]
    }
  },
  methods: {
    getPrimaryStorylaneUrl(item) {
      if (this.isEnglish && item.storylane_en && item.storylane_en.url) {
        return item.storylane_en.url
      }
      if (item.storylane_de && item.storylane_de.url) {
        return item.storylane_de.url
      }
      return item.storylane_en?.url || null
    },
    openModal(url) {
      this.activeModalUrl = url
      document.body.style.overflow = 'hidden'
    },
    closeModal() {
      this.activeModalUrl = null
      document.body.style.overflow = ''
    }
  }
}
